/** @ngInject */
export function Controller() {
    document.cookie = "sso=none; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT"; //set on production: secure = true
}



// WEBPACK FOOTER //
// ./src/portal/states/public/saml-logout/saml-logout.controller.js